import React, { useState, useEffect } from 'react'
import 'antd/lib/select/style/index.css'
import { Card, CardBody, Col, Row } from "reactstrap"
import { Pagination, message } from "antd"
import FilterIssue from './filter/FilterIssue'
import FilterUpdateAt from './filter/FilterUpdateAt'
import FilterInput from './filter/FilterInput'
import IssuesManagementTable from './table/IssuesManagementTable'
import UseDebounce from './helpers/UseDebounce'
import { getListIssues, getListIssueTypes, getExportIssue } from '../../../services/api/apiFFM'
import { SOLUTION, STATUS, SUPPLIER_CONFIRM, ERROR_STAGES } from './helpers/FilterLists'
import { toQueryString } from '../../helpers/toQueryString'
import downloadFileFromData from '../../helpers/downloadFileFromData'
import moment from 'moment'
import { Link } from 'react-router-dom'

const IssuesManagementPage = (props) => {
    const { idSupplier } = props
    const startOfMonth = moment().startOf('month')
    const endOfMonth = moment().endOf('month')

    const [listIssues, setListIssues] = useState([])
    const [fieldSearch, setFieldSearch] = useState('barcode')
    const [valueSearch, setValueSearch] = useState('')
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [pushAt, setPushAt] = useState('')
    const [approvedAt, setApprovedAt] = useState('')
    const [approvedAtDraft, setApprovedAtDraft] = useState({
        from: startOfMonth,
        to: endOfMonth
    })
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [filters, setFilters] = useState({})
    const [issueType, setIssueType] = useState([])
    const [confirmationOverdueTotal, setConfirmationOverdueTotal] = useState(0)

    const { reference_number, confirm_by, issue_type, solution, status, supplier_confirm, error_stage } = filters

    const deBounceValueSearch = valueSearch === '' ? UseDebounce(valueSearch, 0) : UseDebounce(valueSearch, 500)
    const deBounceSearchUser = confirm_by === '' ? UseDebounce(confirm_by, 0) : UseDebounce(confirm_by, 500)
    const deBounceSearchBarcodeItem = reference_number === '' ? UseDebounce(reference_number, 0) : UseDebounce(reference_number, 500)

    useEffect(() => {
        _fetchListIssueType()
    }, [])

    useEffect(() => {
        _fetchListIssue()
    }, [deBounceValueSearch, deBounceSearchUser, deBounceSearchBarcodeItem, pushAt, approvedAt, issue_type, solution, status, page, limit, supplier_confirm, error_stage, idSupplier])

    const _fetchListIssue = async () => {
        setLoading(true)
        setError('')
        setListIssues([])
        try {
            const { issue_type, solution, status, supplier_confirm } = filters
            const query = {
                status: !!status ? status : ['checking', 'confirmed', 'approved'],
                supplier: idSupplier,
                issue_cat: "production",
            }

            if (!!deBounceValueSearch) {
                if (fieldSearch === "barcode") {
                    const barcode = !!deBounceValueSearch ? deBounceValueSearch.replaceAll("#", '').split("_")[0] : ''
                    query[fieldSearch] = splitValue(barcode)
                } else {
                    query[fieldSearch] = splitValue(deBounceValueSearch)
                }
            }

            if (!!deBounceSearchBarcodeItem) {
                query.reference_number = splitValue(deBounceSearchBarcodeItem)
            }

            if (!!issue_type) {
                query.issue_type = issue_type
            }

            if (!!solution) {
                query.solution = solution
            }

            if (!!supplier_confirm) {
                query.supplier_confirm = supplier_confirm
            }

            if (!!error_stage) {
                query.error_stage = error_stage // @FAC-25799
            }

            if (!!deBounceSearchUser) {
                query.confirm_by = splitValue(deBounceSearchUser)
            }

            if (!!pushAt && !!pushAt.pushed_at) {
                query.pushed_at = pushAt.pushed_at
            }

            if (!!approvedAt && !!approvedAt.approved_at) query.approved_at = approvedAt.approved_at

            if (!!approvedAtDraft && !!approvedAtDraft.from && !!approvedAtDraft.to) {
                query.approved_at = {
                    from: approvedAtDraft.from.format("DD/MM/YYYY"),
                    to: approvedAtDraft.to.format("DD/MM/YYYY")
                }
            }

            const payload = {
                page,
                limit,
                query,
                sort: "-approved_at",
                factory: 'MCVN'
            }

            const { data, success, message: mess } = await getListIssues(payload)
            if (!success) return setError(mess)

            const { issues, total, confirmationOverdueTotal } = Object.assign({}, data)
            setListIssues(issues)
            setTotal(total)
            setConfirmationOverdueTotal(confirmationOverdueTotal)

        } catch (error) {
            setError(error?.message)
        } finally {
            setLoading(false)
        }
    }

    const _fetchListIssueType = async () => {
        try {
            const { data, success, message: mess } = await getListIssueTypes()
            if (!success) return message.error(mess)
            const { production } = Object.assign({}, data)

            const listIssueType = production.map(i => ({
                label: i.name,
                value: i._id
            }))
            setIssueType(listIssueType)

        } catch (error) {
            message.error(error.message)
        }
    }

    const splitValue = (value) => {
        if (!value) return []

        return value.replace(/ /g, ',').split(',').map(i => i.trim()).filter(Boolean)
    }

    const handleResetDateDraft = () => {
        setApprovedAtDraft({
            from: '',
            to: ''
        })
    }

    const handleExportIssue = async () => {
        setLoading(true)
        try {
            const { issue_type, solution, status } = filters

            const query = {
                status: !!status ? status : ['checking', 'confirmed', 'approved'],
                supplier: idSupplier,
                issue_cat: "production",
            }

            if (!!deBounceValueSearch) {
                if (fieldSearch === "barcode") {
                    const barcode = !!deBounceValueSearch ? deBounceValueSearch.replaceAll("#", '').split("_")[0] : ''
                    query[fieldSearch] = splitValue(barcode)
                } else {
                    query[fieldSearch] = splitValue(deBounceValueSearch)
                }
            }

            if (!!deBounceSearchBarcodeItem) {
                query.reference_number = splitValue(deBounceSearchBarcodeItem)
            }

            if (!!issue_type) {
                query.issue_type = issue_type
            }

            if (!!solution) {
                query.solution = solution
            }

            if (!!status) {
                query.status = status
            }

            if (!!supplier_confirm) {
                query.supplier_confirm = supplier_confirm
            }

            if (!!error_stage) {
                query.error_stage = error_stage // @FAC-25799
            }

            if (!!deBounceSearchUser) {
                query.confirm_by = splitValue(deBounceSearchUser)
            }

            if (!!pushAt && !!pushAt.pushed_at) {
                query.pushed_at = pushAt.pushed_at
            }

            if (!!approvedAt && !!approvedAt.approved_at) query.approved_at = approvedAt.approved_at

            if (!!approvedAtDraft && !!approvedAtDraft.from && !!approvedAtDraft.to) {
                query.approved_at = {
                    from: approvedAtDraft.from.format("DD/MM/YYYY"),
                    to: approvedAtDraft.to.format("DD/MM/YYYY")
                }
            }

            const payload = {
                page,
                limit,
                query,
                filename: `ListIssue-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv`,
                sort: "-approved_at",
                factory: 'MCVN'
            }

            const response = await getExportIssue(toQueryString(payload))
            const { success, message: mess } = response
            if (!!mess) return message.error('Dữ liệu chưa được export!')

            downloadFileFromData(response, { filename: `ListIssue-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })

        } catch (e) {
            alert(e.toString())
        } finally {
            setLoading(false)
        }
    }

    const handleChangeFilter = (field, value) => {
        setFilters({
            ...filters,
            [field]: value
        })
        setPage(1)
    }

    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _handleChangeFieldSeach = field => {
        setFieldSearch(field)
        setValueSearch('')
    }

    const _hanldeChangeValueSearch = value => {
        setValueSearch(value)
        setPage(1)
    }

    const _handleChangePushAt = filter => {
        setPushAt({ ...filter })
        setPage(1)
    }

    const _handleChangeApprovedAT = filter => {
        setApprovedAt({ ...filter })
        setPage(1)
    }

    return (
        <div className='IssuesManagementPage'>
            <Card>
                <div className="CardHeader card-header header-elements-inline">
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <h1 className='card-title'>Quản lý đơn lỗi</h1>
                        <div className="actions">
                            <Link to='/issues-management/report' className='btn btn-outline-primary'>
                                <i className="fa fa-bar-chart mr-1" />Báo cáo
                            </Link>
                            <button
                                className='btn btn-outline-primary ml-2 mb-0'
                                onClick={handleExportIssue}
                                disabled={loading}
                            >
                                Export
                            </button>
                        </div>
                    </div>
                </div>
                <CardBody>
                    <div className="IssueFilters mb-3 p-3">
                        <Row className="mb-2">
                            <Col lg={3} className="mr-1">
                                <FilterIssue
                                    handleChangeFieldSeach={_handleChangeFieldSeach}
                                    hanldeChangeValueSearch={_hanldeChangeValueSearch}
                                    valueSearch={valueSearch}
                                    fieldSearch={fieldSearch}
                                />
                            </Col>
                            <Col lg={2} className="mr-1">
                                <FilterInput
                                    placeholder="Tìm kiếm barcode item"
                                    onChange={handleChangeFilter}
                                    field='reference_number'
                                />
                            </Col>
                            <Col lg={2} className="mr-1">
                                <FilterInput
                                    options={issueType}
                                    placeholder="Loại lỗi"
                                    onChange={handleChangeFilter}
                                    field='issue_type'
                                    type='select'
                                    showSearch={true}
                                />
                            </Col>
                            <Col lg={1} className="mr-1">
                                <FilterInput
                                    options={SOLUTION}
                                    placeholder="Giải pháp"
                                    onChange={handleChangeFilter}
                                    field='solution'
                                    type='select'
                                />
                            </Col>
                            <Col lg={1} className="mr-3">
                                <FilterInput
                                    options={SUPPLIER_CONFIRM}
                                    placeholder="Kết quả duyệt"
                                    onChange={handleChangeFilter}
                                    field='supplier_confirm'
                                    type='select'
                                />
                            </Col>
                            <Col lg={2} className="mr-1">
                                <FilterInput
                                    options={STATUS}
                                    placeholder="Trạng thái"
                                    onChange={handleChangeFilter}
                                    field='status'
                                    type='select'
                                    value={status}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={3} className="mr-1">
                                <FilterInput
                                    placeholder="Tìm kiếm người duyệt"
                                    onChange={handleChangeFilter}
                                    field='confirm_by'
                                />
                            </Col>
                            <Col lg={2} className="mr-1">
                                <FilterUpdateAt
                                    handleChangeDate={_handleChangePushAt}
                                    updated={pushAt}
                                    placeholder={['Pushed at', 'Pushed end']}
                                    field="pushed_at"
                                />
                            </Col>
                            <Col lg={2} className="mr-1">
                                <FilterUpdateAt
                                    handleChangeDate={_handleChangeApprovedAT}
                                    updated={approvedAt}
                                    placeholder={['Created start', 'Created end']}
                                    field="approved_at"
                                    valueDraft={approvedAtDraft}
                                    onResetDateDraft={handleResetDateDraft}
                                />
                            </Col>
                            <Col lg={2} className="mr-1">
                                <FilterInput
                                    options={ERROR_STAGES}
                                    placeholder="Công đoạn lỗi"
                                    onChange={handleChangeFilter}
                                    field='error_stage'
                                    type='select'
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="d-flex justify-content-end mb-3">
                        <div className='d-flex align-items-center justify-content-end'>
                            {!!confirmationOverdueTotal &&
                                <div className='confirmationOverdueTotal d-flex align-items-center ml-3'>
                                    <div className='confirmationOverdueTotalContent ml-3' onClick={() => handleChangeFilter('status', 'confirmation_overdue')}>
                                        {`${confirmationOverdueTotal} lỗi quá hạn duyệt!`}
                                    </div>
                                </div>
                            }
                            <div className='d-flex align-items-center ml-1'>
                                <div className='ml-3'>Tổng: <span className='font-weight-bold'>{total || 0}</span></div>
                            </div>
                        </div>
                    </div>

                    <IssuesManagementTable
                        listIssues={listIssues}
                        loading={loading}
                        error={error}
                        reload={_fetchListIssue}
                        idSupplier={idSupplier}
                    />

                    <Pagination
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        className='text-right mt-3'
                        pageSize={limit}
                        showSizeChanger
                        current={page}
                        total={total}
                    />
                </CardBody>
            </Card>
        </div >
    )
}

export default IssuesManagementPage